import React from 'react';
import {FormattedMessage} from 'react-intl';

import musicIconURL from './music/music.png';
import musicInsetIconURL from './music/music-small.svg';

import penIconURL from './pen/pen.png';
import penInsetIconURL from './pen/pen-small.svg';

import videoSensingIconURL from './videoSensing/video-sensing.png';
import videoSensingInsetIconURL from './videoSensing/video-sensing-small.svg';

import text2speechIconURL from './text2speech/text2speech.png';
import text2speechInsetIconURL from './text2speech/text2speech-small.svg';

import translateIconURL from './translate/translate.png';
import translateInsetIconURL from './translate/translate-small.png';

import makeymakeyIconURL from './makeymakey/makeymakey.png';
import makeymakeyInsetIconURL from './makeymakey/makeymakey-small.svg';

import microbitIconURL from './microbit/microbit.png';
import microbitInsetIconURL from './microbit/microbit-small.svg';
import microbitConnectionIconURL from './microbit/microbit-illustration.svg';
import microbitConnectionSmallIconURL from './microbit/microbit-small.svg';

import ev3IconURL from './ev3/ev3.png';
import ev3InsetIconURL from './ev3/ev3-small.svg';
import ev3ConnectionIconURL from './ev3/ev3-hub-illustration.svg';
import ev3ConnectionSmallIconURL from './ev3/ev3-small.svg';

import wedo2IconURL from './wedo2/wedo.png'; // TODO: Rename file names to match variable/prop names?
import wedo2InsetIconURL from './wedo2/wedo-small.svg';
import wedo2ConnectionIconURL from './wedo2/wedo-illustration.svg';
import wedo2ConnectionSmallIconURL from './wedo2/wedo-small.svg';
import wedo2ConnectionTipIconURL from './wedo2/wedo-button-illustration.svg';

import boostIconURL from './boost/boost.png';
import boostInsetIconURL from './boost/boost-small.svg';
import boostConnectionIconURL from './boost/boost-illustration.svg';
import boostConnectionSmallIconURL from './boost/boost-small.svg';
import boostConnectionTipIconURL from './boost/boost-button-illustration.svg';

import gdxforIconURL from './gdxfor/gdxfor.png';
import gdxforInsetIconURL from './gdxfor/gdxfor-small.svg';
import gdxforConnectionIconURL from './gdxfor/gdxfor-illustration.svg';
import gdxforConnectionSmallIconURL from './gdxfor/gdxfor-small.svg';

// YUKAI ->
import JittanInsetImage from './Jittan-icon.svg';
import konashiImage from './konashi/konashi-icon.png';
import konashiInsetImage from './konashi/konashi-inset-img.svg';

import cocorokitImage from './cocorokit/cocorokit-icon.png';
import cocorokitInsetImage from './cocorokit/cocorokit-inset-img.svg';

import cocorokitPlusImage from './cocorokitPlus/cocorokitPlus_main.png';
import cocorokitPlusInsetImage from './cocorokitPlus/cocorokitPlus_inner.svg';

import blockkitImage from './blockkit/blockkit_main.png';
import blockkitInsetImage from './blockkit/blockkit_icon.svg';

import speech2textImage from './speech2text/speech.png';
import trackingjsImage from './kurikit_tracking/tracking.png';

import nscontrollerImage from './nscontroller/nscontroller.png';

import konashi5Image from './konashi5/konashi5-icon.svg';
import konashi5InsetImage from './konashi5/konashi5-inset-img.svg';

import emoBlockImage from './emo/Scratch_emo.png';
import emoBlockInsertIconImage from './emo/bocco-emo_body.png';

// pikoham robot
import pikohamImage from './pikoham/pikoham_main.png';
import pikohamInsetImage from './pikoham/pikoham_icon.svg';

// maker board
import makerBoardInsetIconURL from './kurikit_makerBoard/makerBoardIconLarge.svg';
import makerBoardBasicIconURL from './kurikit_makerBoard/makerBoardBasicMain.png';
import makerBoardAnalogIconURL from './kurikit_makerBoard/makerBoardAnalogMain.png';
import makerBoardDigitalIconURL from './kurikit_makerBoard/makerBoardDigitalMain.png';
import makerBoardAdvanceIconURL from './kurikit_makerBoard/makerBoardAdvanceMain.png';
import makerBoardMessageIconURL from './kurikit_makerBoard/makerBoardMessageMain.png';

// lsit2CSV
import list2CSVIconURL from './list2CSV/list2CSVMain.png';
// NLP extension
import sentimentNLPIconURL from './kurikit_sentiment/SentimentMain.png';
import translateNLPIconURL from './kurikit_translation/TranslationMain.png';
// <- YUKAI

// ml2scratch: https://github.com/champierre/ml2scratch/tree/master/scratch-gui/src/lib/libraries/extensions/ml2scratch
import ml2scratchIconURL from './ml2scratch/ml2scratch.png';
import ml2scratchInsetIconURL from './ml2scratch/ml2scratch-small.png';

// microbit-more-v2
import microbitMoreIconURL from './microbitMore/entry-icon.png';
import microbitMoreInsetIconURL from './microbitMore/inset-icon.svg';
import microbitMoreConnectionIconURL from './microbitMore/connection-icon.svg';
import microbitMoreConnectionSmallIconURL from './microbitMore/connection-small-icon.svg';
import translations from './microbitMore/translations.json';

// posenet2scratch: https://github.com/champierre/posenet2scratch
import posenet2scratchIconURL from './posenet2scratch/posenet2scratch.png';
import posenet2scratchInsetIconURL from './posenet2scratch/posenet2scratch-small.png';

// tm2scratch: https://github.com/champierre/tm2scratch
import tm2scratchIconURL from './tm2scratch/tm2scratch.png';
import tm2scratchInsetIconURL from './tm2scratch/tm2scratch-small.png';

// tmpose2scratch: https://github.com/champierre/tmpose2scratch
import tmpose2scratchIconURL from './tmpose2scratch/tmpose2scratch.png';
import tmpose2scratchInsetIconURL from './tmpose2scratch/tmpose2scratch-small.png';

// chatgpt2scratch: https://github.com/ichiroc/chatgpt2scratch/tree/main
import chatgpt2scratchIconURL from './chatgpt2scratch/chatgpt2scratch.png';
import chatgpt2scratchInsetIconURL from './chatgpt2scratch/chatgpt2scratch-small.png';


const formatMessage = messageData => messageData.defaultMessage;
const version = 'v2-0.2.5';


const translationMapMl2scratch = {
    'ja': {
        'gui.extension.ml2scratch.description': '機械学習を使う'
    },
    'ja-Hira': {
        'gui.extension.ml2scratch.description': 'きかいがくしゅうをつかう'
    }
};
const translationMapPosenet2scratch = {
    'ja': {
        'gui.extension.posenet2scratch.description': '身体の各部分の座標を取得する。'
    },
    'ja-Hira': {
        'gui.extension.posenet2scratch.description': 'からだのかくぶぶんのざひょうをしゅとくする。'
    }
};

const translationMapChatgpt2scratch = {
    'ja': {
        'gui.extension.chatgpt2scratch.description': 'ChatGPT からの返答を得る。'
    },
    'ja-Hira': {
        'gui.extension.chatgpt2scratch.description': 'ChatGPT からのへんとうをえる。'
    }
};

export default [
    {
        name: (
            <FormattedMessage
                id="gui.extension.cocorokit.name"
                default="cocoro kit"
                description="Name for the 'cocoro kit' extension"
            />
        ),
        extensionId: 'ikimono',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: cocorokitImage,
        insetIconURL: cocorokitInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.cocorokit.description"
                default="Control cocoro kit."
                description="Description for the 'cocorokit' extension"
            />
        ),
        featured: true,
        bluetoothRequired: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.cocorokitPlus.name"
                default="cocorokit+"
                description="Name for the 'cocorokit+' extension"
            />
        ),
        extensionId: 'cocorokitservo',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: cocorokitPlusImage,
        insetIconURL: cocorokitPlusInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.cocorokitPlus.description"
                default="Control cocorokit+"
                description="Description for the 'cocorokit+' extension"
            />
        ),
        featured: true,
        bluetoothRequired: true
    },
    {
        name: 'メイカーボード きほんブロック',
        extensionId: 'makerBoard',
        iconURL: makerBoardBasicIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: makerBoardInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="メイカーボードで遊ぶ"
                description="Control maker board"
                id="gui.extension.makerBoard.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: 'メイカーボード デジタルブロック',
        extensionId: 'makerBoardDigital',
        iconURL: makerBoardDigitalIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: makerBoardInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="メイカーボードでデジタルセンサーを使う"
                description="Description for the 'Arduino' extension"
                id="gui.extension.makerBoardDigital.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: 'メイカーボード アナログブロック',
        extensionId: 'makerBoardAnalog',
        iconURL: makerBoardAnalogIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: makerBoardInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="メイカーボードでアナログセンサーを使う"
                description="Description for the 'Arduino' extension"
                id="gui.extension.makerBoardAnalog.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: 'メイカーボード アドバンスブロック',
        extensionId: 'makerBoardAdvance',
        iconURL: makerBoardAdvanceIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: makerBoardInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="メイカーボードのアドバンスブロック"
                description="maker board advance blocks"
                id="gui.extension.makerBoardAdvance.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: 'メイカーボード メッセージ',
        extensionId: 'makerBoardMessage',
        iconURL: makerBoardMessageIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: makerBoardInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="メイカーボードと通信する"
                description="Communicate with maker board"
                id="gui.extension.makerBoardmessage.description"
            />
        ),
        featured: true
    },
    {
        name: 'メイカーボード 機械学習',
        extensionId: 'tinyml',
        iconURL: makerBoardMessageIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: makerBoardInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="メイカーボードで加速度センサの動きを学習させる"
                description="Learn movements of the accelerometer on the maker board"
                id="gui.extension.tinyml.description"
            />
        ),
        featured: true
    },
    {
        name: 'BOCCO emo',
        extensionId: 'BOCCOemo',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: emoBlockImage,
        insetIconURL: emoBlockInsertIconImage,
        description: 'BOCCO emoを動かす',
        featured: true,
        disabled: false,
        internetConnectionRequired: true,
        bluetoothRequired: false,
        helpLink: 'https://moonmile.net'
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.konashi.name"
                default="konashi"
                description="Name for the 'konashi' extension"
            />
        ),
        extensionId: 'konashi',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: konashiImage,
        insetIconURL: konashiInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.konashi.description"
                default="Control konashi board."
                description="Description for the 'konashi' extension"
            />
        ),
        featured: true,
        bluetoothRequired: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.konashi5.name"
                default="konashi5"
                description="Name for the 'konashi5' extension"
            />
        ),
        extensionId: 'konashi5',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: konashi5Image,
        insetIconURL: konashi5InsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.konashi5.description"
                default="Control konashi5 board."
                description="Description for the 'konashi5' extension"
            />
        ),
        featured: true,
        bluetoothRequired: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.pikoham.name"
                default="piko piko robot"
                description="Name for the 'piko piko robot' extension"
            />
        ),
        extensionId: 'pikohamRobot',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: pikohamImage,
        insetIconURL: pikohamInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.pikoham.description"
                default="control piko piko robot"
                description="Description for the 'piko piko robot' extension"
            />
        ),
        featured: true,
        bluetoothRequired: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.blockkit.name"
                default="blockkit"
                description="Name for the 'blockkit' extension"
            />
        ),
        extensionId: 'blockkitservo',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: blockkitImage,
        insetIconURL: blockkitInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.blockkit.description"
                default="Control blockkit"
                description="Description for the 'blockkit' extension"
            />
        ),
        featured: true,
        bluetoothRequired: true
    },
    {
        name: 'リストをCSVファイルにする',
        extensionId: 'list2CSV',
        iconURL: list2CSVIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: JittanInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="リストをCSVファイルでダウンロードする"
                description="Description for the 'Arduino' extension"
                id="gui.extension.list2CSV.description"
            />
        ),
        featured: true
    },
    {
        name: '感情分析',
        extensionId: 'kurikitemotion',
        iconURL: sentimentNLPIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: JittanInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="テキストの感情分析をする"
                description="Description for the 'kurikitemotion' extension"
                id="gui.extension.emotion.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: '翻訳',
        extensionId: 'kurikittranslation',
        iconURL: translateNLPIconURL,
        collaborator: 'Yukai Engineering Inc.',
        insetIconURL: JittanInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="テキストの翻訳をする"
                description="Description for the 'kurikittranslation' extension"
                id="gui.extension.translation.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.webkitrecognition.name"
                default="Speech to Text"
                description="Name for the 'webkitrecognition' extension"
            />
        ),
        extensionId: 'webkitrecognition',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: speech2textImage,
        insetIconURL: JittanInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.webkitrecognition.description"
                default="Convert speech into text using Web Speech API."
                description="Description for the 'webkitrecognition' extension"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.trackingjs.name"
                default="tracking"
                description="Name for the 'trackingjs' extension"
            />
        ),
        extensionId: 'kurikitTracking',
        collaborator: 'Yukai Engineering Inc.',
        description: (
            <FormattedMessage
                id="gui.extension.trackingjs.description"
                default="tracking"
                description="Description for the 'kurikitTracking' extension"
            />
        ),
        iconURL: trackingjsImage,
        insetIconURL: JittanInsetImage,
        featured: true
    },
    {
        name: (
            <FormattedMessage
                id="gui.extension.nsjoycon.name"
                default="NS Joy-Con"
                description="Name for the 'NS Joy-Con' extension"
            />
        ),
        extensionId: 'nsjoycon',
        collaborator: 'Yukai Engineering Inc.',
        iconURL: nscontrollerImage,
        insetIconURL: JittanInsetImage,
        description: (
            <FormattedMessage
                id="gui.extension.nsjoycon.description"
                default="Catch inputs from Joy-Con of Nintendo Switch"
                description="Description for the 'NS Joy-Con' extension"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true
    },
    {
        name: 'ChatGPT2Scratch',
        extensionId: 'chatgpt2scratch',
        // extensionURL: 'https://ichiroc.github.io/chatgpt2scratch/chatgpt2scratch.mjs',  // オリジナルソースのURLが間違っていたため修正
        collaborator: 'ichiroc',
        iconURL: chatgpt2scratchIconURL,
        insetIconURL: chatgpt2scratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="ChatGPT2Scratch Blocks."
                description="Description for CHATGPT2Scratch Blocks"
                id="gui.extension.chatgpt2scratch.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: false,
        internetConnectionRequired: true,
        helpLink: 'https://github.com/ichiroc/chatgpt2scratch/',
        translationMap: translationMapChatgpt2scratch
    },
    {
        name: 'TM2Scratch',
        extensionId: 'tm2scratch',
        collaborator: 'Tsukurusha, YengawaLab and Google',
        iconURL: tm2scratchIconURL,
        insetIconURL: tm2scratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="画像や音声を学習させよう。"
                description="画像や音声を学習させよう。"
                id="gui.extension.tm2scratchblocks.description"
            />
        ),
        featured: true,
        disabled: false,
        internetConnectionRequired: true,
        bluetoothRequired: false
    },
    {
        name: 'TMPose2Scratch',
        extensionId: 'tmpose2scratch',
        collaborator: 'Tsukurusha, YengawaLab and Google',
        iconURL: tmpose2scratchIconURL,
        insetIconURL: tmpose2scratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="ポーズを学習させよう。"
                description="ポーズを学習させよう。"
                id="gui.extension.tmpose2scratchblocks.description"
            />
        ),
        featured: true,
        disabled: false,
        internetConnectionRequired: true,
        bluetoothRequired: false
    },
    {
        name: 'ML2Scratch',
        extensionId: 'ml2scratch',
        collaborator: 'champierre',
        iconURL: ml2scratchIconURL,
        insetIconURL: ml2scratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="ML2Scratch Blocks."
                description="Description for ML2Scratch Blocks."
                id="gui.extension.ml2scratchblocks.description"
            />
        ),
        featured: true,
        disabled: false,
        internetConnectionRequired: true,
        bluetoothRequired: false,
        helpLink: 'https://github.com/champierre/ml2scratch/',
        translationMap: translationMapMl2scratch
    },
    {
        name: 'posenet2Scratch',
        extensionId: 'posenet2scratch',
        collaborator: 'champierre',
        iconURL: posenet2scratchIconURL,
        insetIconURL: posenet2scratchInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Obtain the coordinates of each part of the body."
                description="Description for PoseNet2Scratch Blocks."
                id="gui.extension.posenet2scratch.description"
            />
        ),
        featured: true,
        disabled: false,
        internetConnectionRequired: true,
        bluetoothRequired: false,
        helpLink: 'https://github.com/champierre/posenet2scratch/',
        translationMap: translationMapPosenet2scratch
    },

    // mbit-more-v2
    {
        get name () {
            return `${formatMessage({
                defaultMessage: 'MicroBit More',
                description: 'Name of this extension',
                id: 'mbitMore.entry.name'
            })} (${version})`;
        },
        extensionId: 'microbitMore',
        extensionURL: null,
        collaborator: 'Yengawa Lab',
        iconURL: microbitMoreIconURL,
        insetIconURL: microbitMoreInsetIconURL,
        get description () {
            return formatMessage({
                defaultMessage: 'Play with all functions of micro:bit.',
                description: "Description for the 'Microbit More' extension",
                id: 'mbitMore.entry.description'
            });
        },
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: false,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: microbitMoreConnectionIconURL,
        connectionSmallIconURL: microbitMoreConnectionSmallIconURL,
        get connectingMessage () {
            return formatMessage({
                defaultMessage: 'Connecting',
                description: 'Message to help people connect to their micro:bit.',
                id: 'gui.extension.microbit.connectingMessage'
            });
        },
        helpLink: 'https://microbit-more.github.io/',
        translationMap: translations
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Music"
                description="Name for the 'Music' extension"
                id="gui.extension.music.name"
            />
        ),
        extensionId: 'music',
        iconURL: musicIconURL,
        insetIconURL: musicInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Play instruments and drums."
                description="Description for the 'Music' extension"
                id="gui.extension.music.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Pen"
                description="Name for the 'Pen' extension"
                id="gui.extension.pen.name"
            />
        ),
        extensionId: 'pen',
        iconURL: penIconURL,
        insetIconURL: penInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Draw with your sprites."
                description="Description for the 'Pen' extension"
                id="gui.extension.pen.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Video Sensing"
                description="Name for the 'Video Sensing' extension"
                id="gui.extension.videosensing.name"
            />
        ),
        extensionId: 'videoSensing',
        iconURL: videoSensingIconURL,
        insetIconURL: videoSensingInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Sense motion with the camera."
                description="Description for the 'Video Sensing' extension"
                id="gui.extension.videosensing.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Text to Speech"
                description="Name for the Text to Speech extension"
                id="gui.extension.text2speech.name"
            />
        ),
        extensionId: 'text2speech',
        collaborator: 'Amazon Web Services',
        iconURL: text2speechIconURL,
        insetIconURL: text2speechInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Make your projects talk."
                description="Description for the Text to speech extension"
                id="gui.extension.text2speech.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Translate"
                description="Name for the Translate extension"
                id="gui.extension.translate.name"
            />
        ),
        extensionId: 'translate',
        collaborator: 'Google',
        iconURL: translateIconURL,
        insetIconURL: translateInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Translate text into many languages."
                description="Description for the Translate extension"
                id="gui.extension.translate.description"
            />
        ),
        featured: true,
        internetConnectionRequired: true
    },
    {
        name: 'Makey Makey',
        extensionId: 'makeymakey',
        collaborator: 'JoyLabz',
        iconURL: makeymakeyIconURL,
        insetIconURL: makeymakeyInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Make anything into a key."
                description="Description for the 'Makey Makey' extension"
                id="gui.extension.makeymakey.description"
            />
        ),
        featured: true
    },
    {
        name: 'micro:bit',
        extensionId: 'microbit',
        collaborator: 'micro:bit',
        iconURL: microbitIconURL,
        insetIconURL: microbitInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Connect your projects with the world."
                description="Description for the 'micro:bit' extension"
                id="gui.extension.microbit.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: microbitConnectionIconURL,
        connectionSmallIconURL: microbitConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their micro:bit."
                id="gui.extension.microbit.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/microbit'
    },
    {
        name: 'LEGO MINDSTORMS EV3',
        extensionId: 'ev3',
        collaborator: 'LEGO',
        iconURL: ev3IconURL,
        insetIconURL: ev3InsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Build interactive robots and more."
                description="Description for the 'LEGO MINDSTORMS EV3' extension"
                id="gui.extension.ev3.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: ev3ConnectionIconURL,
        connectionSmallIconURL: ev3ConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting. Make sure the pin on your EV3 is set to 1234."
                description="Message to help people connect to their EV3. Must note the PIN should be 1234."
                id="gui.extension.ev3.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/ev3'
    },
    {
        name: 'LEGO BOOST',
        extensionId: 'boost',
        collaborator: 'LEGO',
        iconURL: boostIconURL,
        insetIconURL: boostInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Bring robotic creations to life."
                description="Description for the 'LEGO BOOST' extension"
                id="gui.extension.boost.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: true,
        connectionIconURL: boostConnectionIconURL,
        connectionSmallIconURL: boostConnectionSmallIconURL,
        connectionTipIconURL: boostConnectionTipIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their BOOST."
                id="gui.extension.boost.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/boost'
    },
    {
        name: 'LEGO Education WeDo 2.0',
        extensionId: 'wedo2',
        collaborator: 'LEGO',
        iconURL: wedo2IconURL,
        insetIconURL: wedo2InsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Build with motors and sensors."
                description="Description for the 'LEGO WeDo 2.0' extension"
                id="gui.extension.wedo2.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: true,
        connectionIconURL: wedo2ConnectionIconURL,
        connectionSmallIconURL: wedo2ConnectionSmallIconURL,
        connectionTipIconURL: wedo2ConnectionTipIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their WeDo."
                id="gui.extension.wedo2.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/wedo'
    },
    {
        name: 'Go Direct Force & Acceleration',
        extensionId: 'gdxfor',
        collaborator: 'Vernier',
        iconURL: gdxforIconURL,
        insetIconURL: gdxforInsetIconURL,
        description: (
            <FormattedMessage
                defaultMessage="Sense push, pull, motion, and spin."
                description="Description for the Vernier Go Direct Force and Acceleration sensor extension"
                id="gui.extension.gdxfor.description"
            />
        ),
        featured: true,
        disabled: false,
        bluetoothRequired: true,
        internetConnectionRequired: true,
        launchPeripheralConnectionFlow: true,
        useAutoScan: false,
        connectionIconURL: gdxforConnectionIconURL,
        connectionSmallIconURL: gdxforConnectionSmallIconURL,
        connectingMessage: (
            <FormattedMessage
                defaultMessage="Connecting"
                description="Message to help people connect to their force and acceleration sensor."
                id="gui.extension.gdxfor.connectingMessage"
            />
        ),
        helpLink: 'https://scratch.mit.edu/vernier'
    }
];
